import { FC, ReactNode } from 'react';
import { clsx } from 'clsx';
import './DoublePress.scss';

export interface IDoublePressLabelProps {
    armed: boolean;
    /** Надпись взведённой кнопки («Точно удалить?»). */
    armedText: ReactNode;
    /** Обычная надпись. */
    children: ReactNode;
}

/**
 * Надпись кнопки в два нажатия. Обе надписи лежат в одной ячейке сетки: ширина кнопки — по длинной, поэтому взвод
 * не сдвигает соседей и кнопка не уезжает из-под курсора перед вторым нажатием.
 */
const DoublePressLabel: FC<IDoublePressLabelProps> = ({ armed, armedText, children }) => (
    <span className="rf-double-press-label">
        <span className={clsx('rf-double-press-label__text', armed && 'is-hidden')} aria-hidden={armed || undefined}>
            {children}
        </span>
        <span className={clsx('rf-double-press-label__text', !armed && 'is-hidden')} aria-hidden={!armed || undefined}>
            {armedText}
        </span>
    </span>
);

export default DoublePressLabel;
